export const SET_LOADING="SET_LOADING"
export const SET_INVOICES_LIST="SET_INVOICES_LIST"